// extracted by mini-css-extract-plugin
export default {"container":"Scaffold_container__bu7MU"};